export const LOCAL_STORAGE_KEYS = {
  currentUser: 'auth__current_user',
  accessToken: 'auth__access_token',
}
